import { ITanyaVideoPlayer } from "./tanya-video-player.types";
import { useTanyaVideoPlayer } from "./use-tanya-video-player";
import { TanyaVideoPlayerWrapper } from "./tanya-video-player.styles";

import YouTubePlayer from "react-player/youtube";
import FilePlayer from "react-player/file";
import { ReactPlayerProps } from "react-player";
import { VideoPlayerPlaceholder } from "components/video-player-placeholder/video-player-placeholder";

const VideoPlayer = ({
  isYoutube,
  ...props
}: { isYoutube: boolean } & Omit<ReactPlayerProps, "config">) =>
  isYoutube ? <YouTubePlayer {...props} /> : <FilePlayer {...props} />;

const TanyaVideoPlayer: React.FC<ITanyaVideoPlayer> = ({
  videoData,
  playerRef
}) => {
  const videoURL =
    videoData.youtube_url && YouTubePlayer.canPlay(videoData.youtube_url)
      ? { source: videoData.youtube_url, isYoutube: true }
      : { source: videoData.video_url, isYoutube: false };

  const { isPlaying, handlePlayerInit, handlePlay } = useTanyaVideoPlayer();

  return (
    <TanyaVideoPlayerWrapper>
      <VideoPlayer
        ref={playerRef}
        isYoutube={videoURL.isYoutube}
        width="100%"
        height="100%"
        url={videoURL.source}
        playing={isPlaying}
        controls={true}
        pip={false}
        onPlay={handlePlay}
        onDuration={handlePlayerInit}
        playsInline={true}
        onClickPreview={handlePlayerInit}
        light={<VideoPlayerPlaceholder />}
        // playIcon={<Play />}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          transition: "all 0.5s ease"
        }}
      />
    </TanyaVideoPlayerWrapper>
  );
};

export { TanyaVideoPlayer };
